import { ILocationItemResponse } from "../../services/edit-hospital-location/edit-hospital-location.interface";

export const actionTypes = {
  SET_HOSPITAL_LIST: "SET_HOSPITAL_LIST",
  SET_CURRENT_LOCATION: "SET_CURRENT_LOCATION",
  SET_HOSPITAL_LIST_UPDATED: "SET_HOSPITAL_LIST_UPDATED",
};

// actions created to handle storing of getMetrolocations api response
// to restrict reduntant api calls

const setHospitalList = (payload: ILocationItemResponse[]) => ({
  type: actionTypes.SET_HOSPITAL_LIST,
  payload,
});

const setCurrentLocation = (payload: string) => ({
  type: actionTypes.SET_CURRENT_LOCATION,
  payload,
});


const setIsHospitalListUpdated = (payload: boolean) => ({
  type: actionTypes.SET_HOSPITAL_LIST_UPDATED,
  payload,
});


export default {
  setHospitalList,
  setCurrentLocation,
  setIsHospitalListUpdated,
};
